import { Variants } from "framer-motion";

export const cardVariants: Variants = {
	hidden: {
		y: "80px",
		opacity: 0,
	},
	visible: {
		y: "0px",
		opacity: 1,
		transition: {
			duration: 0.6,
			ease: "easeOut",	
		},
	},
};
